import type { CollectionResponse } from '@/types/bff'

export const DDFS_PAGE_SIZE = 100

export async function fetchAllDdfsCollection<T>(
  fetchPage: (page: number, itemsPerPage: number) => Promise<CollectionResponse<T>>,
): Promise<T[]> {
  const firstPage = await fetchPage(1, DDFS_PAGE_SIZE)

  if (firstPage.totalPages <= 1)
    return firstPage.items

  const remainingPages = await Promise.all(
    Array.from(
      { length: firstPage.totalPages - 1 },
      (_, index) => fetchPage(index + 2, DDFS_PAGE_SIZE),
    ),
  )

  return [firstPage.items, ...remainingPages.map(page => page.items)].flat()
}
